
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#9b9b9b","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 -.104)","fill":"inherit"}},[_c('rect',{attrs:{"data-name":"Rectangle 7 Copy 2","width":"15.665","height":"1.305","rx":".5","transform":"rotate(45 .336 1.166)"}}),_c('rect',{attrs:{"data-name":"Rectangle 7 Copy 3","width":"15.665","height":"1.305","rx":".5","transform":"rotate(-45 13.495 5.59)"}})])])
          )
        }
      }
    